export interface IChargePrice {
    chargeModuleCategoryId: number;
    chargeCategoryId: number;
    chargeCategoryName: string;
    locationId: number;
    modulesMasterId: number;
    chargeModuleTemplateId: number;
    chargeModuleDetailsId: number;
    referenceId: number;
    amount: number;
    lastModifiedBy: number;
    lastModifiedByName: string;
    lastModifiedDate: Date;
}